define((require) => {
    "use strict";

    const ImprovedView      = require("editor/zbone/ImprovedView");
    const template          = require("ui/editor/editorMoreMenu/ToggleEmailModeView.tpl");
    const Tooltip           = require("ui/common/Tooltip");

    /**
     * Component representing the Toggle email mode button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {ExperienceModel} model The current experience model.
     *
     * @see EditorPreviewMenu
     *
     * @class ToggleEmailModeView
     */
    return ImprovedView.extend({

        className: "toggle-email-mode-button-container",

        template,

        ui: {
            toggleEmailModeBtn: ".toggle-email-mode"
        },

        events: {
            "click @ui.toggleEmailModeBtn": "toggleEmailMode"
        },

        bindings: {
            ".toggle-email-mode": {
                observe: "emailModeEnabled",
                update: function($el, isEnabled) {
                    const statusText = isEnabled ? "Disable" : "Enable";
                    $el.text(`${statusText} Email Mode`);
                }
            }
        },

        getUniqueEntries(group) {
            if (group) {
                return group.attributes.entries
                    .chain()
                    .reduce((assetsMap, internalAsset) => {
                        const asset = internalAsset.get("asset");

                        if (asset) {
                            const id = asset.get("id");
                            assetsMap[id] = [asset, internalAsset.get("value")];
                        }

                        return assetsMap;
                    }, {})
                    .values()
                    .value();
            }
            return [];
        },

        _toggleDisableEmailButton() {
            const entriesLength = this.getUniqueEntries(this.options.group).length;

            if (entriesLength > 1) {
                this.ui.toggleEmailModeBtn.addClass("disabled");
                Tooltip.create(this.ui.toggleEmailModeBtn, {
                    content: "Email Mode is not available for group of experiences. Please, reduce your experience to a single variant to enable email mode.",
                    width: 380,
                    placement: "bottom"
                });
                return true;
            }
            this.ui.toggleEmailModeBtn.removeClass("disabled");
            Tooltip.remove(this.ui.toggleEmailModeBtn);
            return false;
        },

        onShow() {
            this._toggleDisableEmailButton();
        },

        toggleEmailMode() {
            const isEmailModeEnabled = this.model.get("emailModeEnabled");

            const buttonDisabled = this._toggleDisableEmailButton();
            if (buttonDisabled) return;

            this.model.set("emailModeEnabled", !isEmailModeEnabled);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/editorMoreMenu/ToggleEmailModeView.js